import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const { currentUser } = useAuth();
  const [theme, setTheme] = useState('light'); // default until user loads

  // Initialize theme on mount or when user changes
  useEffect(() => {
    let activeTheme = 'light';
    
    if (currentUser?.themePreference) {
      activeTheme = currentUser.themePreference;
    } else {
      // Default to light mode for all first-time users
      activeTheme = 'light';
    }

    setTheme(activeTheme);
  }, [currentUser]);

  // Apply theme to document element
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = async () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);

    // Persist if user is logged in
    if (currentUser && currentUser.uid) {
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userRef, { themePreference: newTheme });
      } catch (error) {
        console.error("Error saving theme preference:", error);
      }
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
